import {
    useMemo,
} from 'react'

import {
    createRoutesConfig, useSkyNetNavigate,
} from 'app/SkyNetRoutes/index'
import {
    CommonRoutes,
} from 'app/enums/common.enums'

import useCreateSkyNetDomainRoutes from 'app/shared-components/SkyNetDomain/useCreateSkyNetDomainRoutes'
import {
    SkyNetRoutesConfig,
} from 'app/SkyNetRoutes/SkyNetRoutes.types'
import {
    App,
    LoggerTabs,
} from 'app/enums/domain.enums'

export default function useLoggerRoutes() {
    const skyNetNavigate = useSkyNetNavigate()
    const SkyNetDomainRoutes = useCreateSkyNetDomainRoutes()()

    return useMemo(() => {
        const config: SkyNetRoutesConfig = {
            path: [],
            Loggers: {
                route: App.Loggers,
                Overview: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                    params: [{
                        name: 'otherLoggersNumbers',
                        required: false,
                    }],
                },
                Update: {
                    route: CommonRoutes.DataUpdate,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Documents: {
                    route: LoggerTabs.Documents,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                ChangeHistory: {
                    route: CommonRoutes.ChangeHistory,
                    via: SkyNetDomainRoutes.All.Edit,
                },
            },
        }

        return createRoutesConfig(skyNetNavigate)(config)
    }, [
        SkyNetDomainRoutes,
        skyNetNavigate,
    ])
}
